import React, { useContext } from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Link from "next/link";
import { usePathname, useRouter } from "../../hooks/useNavigation";
import PropTypes from "prop-types";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import { horizontalAlignmentMap } from "../../styles/positionMaps";
import Button from "../Button/Button";

function RedirectButton(props) {
  const {
    className,
    buttonClassName,
    text,
    customUrl,
    bgColor,
    color,
    alignment,
    backgroundHoverColour,
    textHoverColour,
  } = props;

  const {
    buttonText,
    buttonAlignment,
    url,
    backgroundColor,
    textColor,
    buttonHoverColour,
    buttonHoverTextColour,
  } = useContext(ComponentContext);

  const { filtersStore } = useStores();
  const { resetAllFilters } = filtersStore;

  const router = useRouter();
  const pathname = usePathname();
  const href = url || customUrl || pathname.split("?")[0];

  const handleReset = () => {
    router
      .push({
        pathname: href,
      })
      .then(resetAllFilters);
  };

  const buttonWrapperClassName = classNames(
    "d-flex justify-content-center",
    [
      `justify-content-lg-${
        horizontalAlignmentMap[buttonAlignment] ||
        horizontalAlignmentMap[alignment] ||
        "center"
      }`,
    ],
    { [className]: !isEmpty(className) }
  );

  const buttonClass = classNames(
    "px-5 d-flex justify-content-center align-items-center",
    {
      [buttonClassName]: !isEmpty(buttonClassName),
    }
  );

  return (
    <div className={buttonWrapperClassName}>
      <Link href={href} passHref legacyBehavior>
        <Button
          className={buttonClass}
          onClick={handleReset}
          buttonColour={bgColor || backgroundColor || undefined}
          buttonTextColour={textColor || color || undefined}
          buttonHoverColour={backgroundHoverColour || buttonHoverColour}
          buttonTextHoverColour={textHoverColour || buttonHoverTextColour}
        >
          {text || buttonText || "Redirect to..."}
        </Button>
      </Link>
    </div>
  );
}

RedirectButton.defaultProps = {
  buttonClassName: "",
  className: "",
  customUrl: undefined,
  text: "",
  bgColor: undefined,
  color: undefined,
  alignment: "center",
  backgroundHoverColour: "",
  textHoverColour: "",
};

RedirectButton.propTypes = {
  buttonClassName: PropTypes.string,
  className: PropTypes.string,
  customUrl: PropTypes.string,
  text: PropTypes.string,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  alignment: PropTypes.string,
  backgroundHoverColour: PropTypes.string,
  textHoverColour: PropTypes.string,
};

export default observer(RedirectButton);
